import { ActionLink, Button } from '@cian/ui-kit';
import { forwardRef } from 'react';
import { TButtonStyle } from './types';

interface IFilterButtonProps {
  children: string;
  buttonStyle?: TButtonStyle;
  onClick: VoidFunction;
}

export const FilterButton = forwardRef<HTMLButtonElement, IFilterButtonProps>(function FilterButton(
  { children, buttonStyle = 'default', onClick },
  ref,
) {
  if (buttonStyle === 'dashed') {
    return (
      <ActionLink textDecoration="dashed" onClick={onClick} fontSize="S" tabIndex={0}>
        {children}
      </ActionLink>
    );
  }

  return (
    <Button onClick={onClick} theme="stroke_secondary" ref={ref} size="XS" tabIndex={0}>
      {children}
    </Button>
  );
});
